var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadUserAuthorizedData)?_c('OrdersInboundDetailUser',{attrs:{"ordersInbound":_vm.ordersInbound}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }